import notificationActionCreators from '../actions/notificationActionCreators';
import store from '../reducers/storeRegistration';

/**
 *  Display a validation error notification
 */
export const evaluate = async (entity, entityName, source, content
// parentContentPath, transientContext, nativeFunctions, sourceEvaluator,
) => {
  store.dispatch(notificationActionCreators.validationError({
    list: source.errors,
    id: content.id
  }, {
    autoClose: 10000
  }));
  return false;
};
export default {
  evaluate
};